const smoothScrollTo = (hashTarget, event) => {
	if(hashTarget === '#-') return;
	var targetElem = document.querySelector(hashTarget);
	if (targetElem) {
		if (event) {
			event.preventDefault();
		}
		var scrollOffset = targetElem.getBoundingClientRect().top + window.pageYOffset;

		var wpAdminBar = document.getElementById('wpadminbar');
		if(wpAdminBar) {
			scrollOffset -= wpAdminBar.offsetHeight;
			console.log('admin bar offset', wpAdminBar.offsetHeight);
		}

		var stickyHeader = document.querySelector('.stickyHeaderScrollOffset');
		if(stickyHeader && stickyHeader.offsetParent !== null) {
			scrollOffset -= stickyHeader.offsetHeight;
			console.log('sticky header offset', stickyHeader.offsetHeight);
		}

		// Smooth scroll animation
		window.scrollTo({
			top: scrollOffset,
			behavior: 'smooth'
		});

		// After scrolling, reset hash
		setTimeout(() => {
			if(window.location.hash !== '') window.location.hash = '-';
		}, 600);
	}
}

document.addEventListener('DOMContentLoaded', () =>{
	// Close mobile navbar after click
	let navbarCollapse = document.querySelector('.navbar-collapse.collapse');
	if (navbarCollapse) {
		navbarCollapse.querySelectorAll('a').forEach((link) => {
			link.addEventListener('click', () => {
				navbarCollapse.classList.remove('in');
			});
		});
	}

	// Initial smooth scrolling on page-load
	if (location.hash) {
		let hash = location.hash;
		setTimeout(() => { smoothScrollTo(hash); }, 500);
	}

	let linkTargets = document.querySelectorAll('a[href*="#"]');
	linkTargets.forEach((link) => {
		link.addEventListener('click', (e) => {
			console.log('click 123', link.hash);
			smoothScrollTo(link.hash, e);
		});
	});
});
